export function getPrintedByText(user = {}) {
    return `${getPrinterName(user)} (${getPrinterEmail(user)})`
}

export function getUncontrolledCopyDisclaimer({ companyName, printedBy, printedOn = new Date() }) {
    const printedDate = formatPrintedDate(printedOn)
    const printedFor = companyName || "Unknown company"
    const printerIdentity = getPrinterIdentityForCompany({ companyName: printedFor, printedBy })
    return `This is an uncontrolled copy printed on ${printedDate} for ${printedFor} by ${printerIdentity}.`
}

export function formatPrintedDate(date = new Date()) {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    return `${day}/${month}/${date.getFullYear()}`
}

export function formatCopyrightYear(date = new Date()) {
    return String(date.getFullYear())
}

function getPrinterName(user) {
    return (
        user.displayName ||
        user.metadata?.displayName ||
        user.$metadata?.displayName ||
        user.UserName ||
        user.email ||
        "Unknown user"
    )
}

function getPrinterEmail(user) {
    return user.email || user.UserName || "unknown email"
}

function getPrinterIdentityForCompany({ companyName, printedBy }) {
    const printerName = getPrintedByName(printedBy)
    const printerEmail = getPrintedByEmail(printedBy)
    if (printerEmail && isSamePersonName(companyName, printerName)) {
        return printerEmail
    }
    return printedBy
}

function getPrintedByName(printedBy) {
    return printedBy?.split("(")?.[0]?.trim()
}

function getPrintedByEmail(printedBy) {
    const match = printedBy?.match(/\(([^)]+)\)/)
    return match?.[1]
}

function isSamePersonName(companyName, printerName) {
    const companyParts = getNameParts(companyName)
    const printerParts = getNameParts(printerName)
    if (companyParts.length < 2 || printerParts.length < 2) return false
    const companySurname = companyParts.at(-1)
    const printerSurname = printerParts.at(-1)
    if (companySurname !== printerSurname) return false
    return haveEquivalentFirstNames(companyParts[0], printerParts[0])
}

function getNameParts(name) {
    return (name || "")
        .toLowerCase()
        .replace(/[^a-z ]/g, " ")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
}

function haveEquivalentFirstNames(left, right) {
    if (left === right) return true
    return getCanonicalFirstName(left) === getCanonicalFirstName(right)
}

function getCanonicalFirstName(name) {
    if (["mike", "michael"].includes(name)) return "michael"
    return name
}
